import React from 'react';

export default function HeroSection() {
  /** 
   * Opens the application form in a new tab.
   * Includes basic error handling for popup blockers and unexpected failures.
   */
  const handleApplyClick = () => {
    try {
      const newWindow = window.open(
        'https://pump.fun/coin/ACbRmtp7G9G7if16KF62eANZhyFKPpSVsaSBkUk6pump',
        '_blank',
        'noopener,noreferrer'
      );
      if (!newWindow) {
        // Most browsers return null when a popup is blocked.
        alert('Please enable pop‑ups for this site to open the application form.');
      }
    } catch (err) {
      console.error('Unable to open the application link:', err);
      alert('Something went wrong. Please try again later.');
    }
  };

  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url('https://static.readdy.ai/image/c3134a847c58ccdd233e9d4ac4101a64/7120a821e0332ef1e3f1cf75836af96f.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-purple-900/90 via-slate-900/80 to-emerald-900/90"></div>

      {/* Animated floating elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-3 h-3 bg-purple-400 rounded-full animate-bounce"></div>
        <div className="absolute bottom-32 left-1/4 w-1 h-1 bg-emerald-300 rounded-full animate-ping"></div>
        <div className="absolute bottom-20 right-1/3 w-2 h-2 bg-purple-300 rounded-full animate-pulse"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-6xl mx-auto">
        {/* Logo / Badge */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            {/* Placeholder logo – replace with actual image or SVG if needed */}
            <div className="w-24 h-24 rounded-full bg-gradient-to-br from-emerald-400 to-purple-5

0 flex items-center justify-center text-white text-2xl font-bold">
              PSU
            </div>
          </div>
        </div>

        {/* Main Title */}
        <h1 className="text-6xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 via-purple-400 to-emerald-400 mb-6 leading-tight">
          Welcome to<br />
          <span className="text-5xl md:text-7xl">PumpFun Streamer</span>
          <br />
          <span className="text-6xl md:text-8xl">University</span>
        </h1>

        {/* Subtitle */}
        <p className="text-2xl md:text-3xl text-gray-200 mb-12 font-semibold">
          Where creators{' '}
          <span className="text-emerald-400">learn</span>,{' '}
          <span className="text-purple-400">earn</span>, and{' '}
          <span className="text-emerald-400">pump</span> together.
        </p>

        {/* Call‑to‑Action Button */}
        <button
          onClick={handleApplyClick}
          className="group relative inline-flex items-center px-12 py-6 text-xl font-bold text-white bg-gradient-to-r from-emerald-500 to-purple-600 rounded-full hover:from-emerald-400 hover:to-purple-500 transform hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-emerald-500/25 whitespace-nowrap cursor-pointer"
        >
          <span className="relative z-10 flex items-center">
            <i className="ri-graduation-cap-fill mr-3 text-2xl"></i>
            Apply to Join PSU
            <i className="ri-arrow-right-line ml-3 text-xl group-hover:translate-x-1 transition-transform"></i>
          </span>
          <div className="absolute inset-0 bg-gradient-to-r from-emerald-600 to-purple-7

00 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </button>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-1 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-black text-emerald-400 mb-2">24/7</div>
            <div className="text-gray-300 font-medium">Community Support</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-gray-400"></i>
      </div>
    </section>
  );
}
